import { render, staticRenderFns } from "./batchbeshipped.vue?vue&type=template&id=3192791e&scoped=true"
import script from "./batchbeshipped.vue?vue&type=script&lang=ts"
export * from "./batchbeshipped.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3192791e",
  null
  
)

export default component.exports